import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(t.login);
      const to = location.state?.from || (res.user.role === "super_admin" ? "/admin" : "/dashboard");
      navigate(to);
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <Card className="p-8">
        <h1 className="font-serif text-3xl mb-1">{t.login}</h1>
        <p className="text-sm text-muted-foreground mb-6">{t.brand} · {t.tagline}</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">{t.email}</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
          </div>
          <div>
            <Label htmlFor="password">{t.password}</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full h-11" data-testid="login-submit">
            {loading ? "..." : t.login}
          </Button>
        </form>
        <div className="mt-6 text-sm text-muted-foreground">
          {t.register} → <Link to="/register" className="text-primary underline underline-offset-4" data-testid="to-register">{t.register}</Link>
        </div>
      </Card>
    </div>
  );
}
